module.exports = __webpack_public_path__ + "static/media/logoMKrounded.2ef3e3c7.png";